<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.edit.serviceData.other.nLine' | translate}} {{dL!.NumeroLinea}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px" *ngIf="dL">
    <div class="row" style="margin-left: 0px" >
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label for="nL" class="roboSubTitle">{{'N. Linea' | translate}}</label>
            <input class="form-control" type="text" id="nL" readonly [(ngModel)]="dL.NumeroLinea">
        </div>
        <div class="col-2" *ngIf="!dL.CodiceArticolo[0]">
            <label for="cT" class="roboSubTitle">{{'Cod. Articolo' | translate}}</label>
            <div style="padding: 10px;">
                <button (click)="addCodiceArticolo()">{{'general.add' | translate}}</button>
            </div>
        </div>
        <div class="col-2" *ngIf="dL.CodiceArticolo[0]">
            <label for="cT" class="roboSubTitle">{{'Cod. Tipo' | translate}}</label>
            <input class="form-control" type="text" id="cT" [(ngModel)]="dL.CodiceArticolo[0].CodiceTipo">
        </div>
        <div class="col-2" *ngIf="dL.CodiceArticolo[0]">
            <label for="cV" class="roboSubTitle">{{'Cod. Valore' | translate}}</label>
            <input class="form-control" type="text" id="cV" [(ngModel)]="dL.CodiceArticolo[0].CodiceValore">
            <div style="padding: 10px;">
                <button (click)="deleteCodiceArticolo(dL.CodiceArticolo[0])">{{'general.delete' | translate}}</button>
            </div>
        </div>
        
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div class="col-12">
            <label class="roboSubTitle">{{'invoices.edit.serviceData.other.description' | translate}}</label>
            <textarea class="form-control" type="text" multiple [(ngModel)]="dL.Descrizione" [maxlength]="1000" oninput="javascript: this.value = this.value.replace(/[^\x00-\x7F]/g, '');"></textarea>
            <span [innerHTML]="dL.Descrizione.length + '/1000'"></span>
        </div>
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <label class="roboSubTitle">{{'invoices.edit.serviceData.other.date_s' | translate}}</label>
            <div class="input-group dm7DatePicker" style="max-width:220px">
                <input class="form-control" placeholder="gg-mm-aaaa"
                        name="d2" #c2="ngModel" [(ngModel)]="dL.DataInizioPeriodo"
                        readonly
                        ngbDatepicker #d2="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important; "
                    (click)="dL.DataInizioPeriodo = '';" type="button">
                    <i class="bi bi-x-lg"></i>
                </button>
                <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                    <i class="bi bi-calendar-week"></i>
                </button>
            </div>
        </div>
        <div [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767 }">
            <label class="roboSubTitle">{{'invoices.edit.serviceData.other.date_e' | translate}}</label>
            <div class="input-group dm7DatePicker" style="max-width:220px">
                <input class="form-control" placeholder="gg-mm-aaaa"
                        name="d1" #c1="ngModel" [(ngModel)]="dL.DataFinePeriodo"
                        readonly
                        ngbDatepicker #d1="ngbDatepicker">
                <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important; "
                    (click)="dL.DataFinePeriodo = '';" type="button">
                    <i class="bi bi-x-lg"></i>
                </button>
                <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">
                    <i class="bi bi-calendar-week"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <div class="col-12">
            <label for="nL" class="roboSubTitle">{{'invoices.edit.serviceData.other.rifAmm' | translate}}</label>
            <input class="form-control" type="text" id="nL" [(ngModel)]="dL.RiferimentoAmministrazione">
        </div>
    </div>
    <div class="row" style="margin-left: 0px; margin-top: 10px;" >
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li *ngFor="let tab of configTabs.config" class="nav-item" role="presentation">
                <button class="nav-link" [ngClass]="{'active': configTabs.selected == tab.id}"  (click)="configTabs.selected = tab.id" [id]="tab.id + '-tab'" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="false">
                {{tab.name| translate}}
                </button>
            </li>
        </ul>
        <div class="tab-content">
            <!-- DETTAGLIO LINEE -->
            <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 1}" id="1" role="tabpanel" aria-labelledby="home-tab">
                <div style="display: flex;justify-content: end; padding: 10px;">
                    <button (click)="addScontoMaggiorazione()">{{'general.add' | translate}}</button>
                </div>
                <div>
                    <table class="table table-responsive">
                        <thead>
                            <tr>
                                <th class="col-6">{{'invoices.edit.serviceData.other.type' | translate}}</th>
                                <th class="col-3">{{'invoices.edit.serviceData.other.percentage' | translate}}</th>
                                <th class="col-3">{{'invoices.edit.serviceData.other.amount' | translate}}</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let val of dL.ScontoMaggiorazione; let i = index;">
                                <td>
                                    <app-select class="selectDm7" 
                                        [options]="[{val:'SC',label:'Sconto'},{val:'MG',label:'Maggiorazione'}]"
                                        [key]="'val'" [value]="'label'" [selectedKey]="val.Tipo"
                                        [placeholder]="'placeholder.select' | translate"
                                        (change)="val.Tipo = $event.key"></app-select>
                                </td>
                                <td>
                                    <input type="text"  placement="top"  [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.perc' | translate" 
                                                    [disabled]="val.Importo != '' && val.Importo != '0' && val.Importo != '0.0' && val.Importo != '0.00'" smart-float class="form-control" 
                                                    [placeholder]="'invoices.edit.serviceData.other.percentage' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.Percentuale">
                                </td>
                                <td>
                                    <input type="text"  placement="top"  [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.imp' | translate" 
                                            [disabled]="val.Percentuale != '' && val.Percentuale != '0' && val.Percentuale != '0.0' && val.Percentuale != '0.00'" smart-float class="form-control" 
                                            [placeholder]="'invoices.edit.serviceData.other.amount' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.Importo">
                                </td>
                                <td>
                                    <button type="button" class="btn btn-danger" (click)="deleteScontoMaggiorazione(i); getTotImporto()"><img src="assets/icone_varie/cestino.svg"></button>
                                </td>
                            </tr>
                        </tbody>    
                    </table>
                </div>
            </div>
            <!-- ALTRI DATI GESTIONALI -->
            <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 2}" id="2" role="tabpanel" aria-labelledby="home-tab">
                <div style="display: flex;justify-content: end; padding: 10px;">
                    <button (click)="addDatiGestionali()">{{'general.add' | translate}}</button>
                </div>
                <div>
                    <table class="table table-responsive">
                        <thead>
                            <tr>
                                <th class="col-3">{{'invoices.edit.serviceData.other.typeData' | translate}}</th>
                                <th class="col-3">{{'invoices.edit.serviceData.other.rifNumm' | translate}}</th>
                                <th class="col-3">{{'invoices.edit.serviceData.other.rifText' | translate}}</th>
                                <th class="col-3">{{'invoices.edit.serviceData.other.rifDate' | translate}}</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let val of dL.AltriDatiGestionali; let i = index;">
                                <td>
                                    <input type="text" class="form-control" [maxlength]="10" [ngClass]="[val.TipoDato != '' ? '' : 'borderRed']" [placeholder]="'invoices.edit.serviceData.other.typeData' | translate" [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.typeData' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.TipoDato">
                                </td>
                                <td>
                                    <!--<input type="text" oninput="javascript:this.value=this.value.replace(/([^\d]*)(\d*(\.\d{0,2})?)(.*)/, '$2');" class="form-control" [placeholder]="'invoices.edit.serviceData.other.rifNumm' | translate" [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.rifNum' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumero">-->
                                    <input type="text" oninput="javascript:this.value=this.value.replace(/([^\d]*)(\d*(\.\d{0,2})?)([a-zA-Z])/, '$2');" class="form-control" [placeholder]="'invoices.edit.serviceData.other.rifNumm' | translate" [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.rifNum' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumero">
                                </td>
                                <td>
                                    <input type="text" class="form-control" [maxlength]="60" [placeholder]="'invoices.edit.serviceData.other.rifText' | translate" [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.rifText' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoTesto">
                                </td>
                                <td>
                                    <!--<div class="input-group dm7DatePicker" >-->
                                    <div class="input-group dm7DatePicker" style="position: absolute; max-width: 200px; overflow: visible;">
                                        <input class="form-control" placeholder="gg-mm-aaaa" 
                                                name="d2" #c2="ngModel" [(ngModel)]="val.RiferimentoData"
                                                readonly
                                                [ngbTooltip]="'invoices.edit.serviceData.other.tooltip.rifData' | translate"
                                                ngbDatepicker #d2="ngbDatepicker">
                                        <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                            (click)="val.RiferimentoData = '';" type="button">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                        <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                            <i class="bi bi-calendar-week"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-danger" (click)="deleteDatiGestionali(i)"><img src="assets/icone_varie/cestino.svg"></button>
                                </td>
                            </tr>
                        </tbody>    
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()">{{ 'general.save' | translate }}</button>
</div>